/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WeatherThermometerIcon20Regular = forwardRef('WeatherThermometerIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.25 11.114a2.501 2.501 0 1 0 1.5 0V6.75a.75.75 0 0 0-1.5 0v4.364ZM10 12.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.25 4.75a3.75 3.75 0 1 1 7.5 0v4.727a5.5 5.5 0 1 1-7.5 0V4.75ZM10 2.5a2.25 2.25 0 0 0-2.25 2.25v5.067a.75.75 0 0 1-.276.581 4 4 0 1 0 5.052 0 .75.75 0 0 1-.276-.58V4.75A2.25 2.25 0 0 0 10 2.5Z" })));
});
